import { memo, useCallback, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { TabNav } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

import { PeopleAccessHeaderContext } from '../context/PeopleAccessHeaderContext.js';
import { usePeopleAccessTabs } from '../hooks/usePeopleAccessTabs.js';
import PeopleAccessTab from './PeopleAccessTab';

/** Last non-empty segment of a pathname: `/people-access/roles/` → `roles`. */
const lastSegment = (pathname) => pathname.split('/').filter(Boolean).pop();

/** Members / Roles / Groups tabs of the list screens (the viewer's visible tabs only). */
function PeopleAccessTabs() {
  const { t } = useTranslation('people-access');
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { basePath } = useContext(PeopleAccessHeaderContext);
  const tabs = usePeopleAccessTabs();
  const activeTab = lastSegment(pathname);

  const handleSelectTab = useCallback((id) => navigate(`${basePath}/${id}`), [navigate, basePath]);

  return (
    <TabNav ariaLabel={t('tabs.ariaLabel')}>
      {tabs.map(({ id, labelKey }) => (
        <PeopleAccessTab
          key={id}
          id={id}
          label={t(labelKey)}
          selected={activeTab === id}
          onSelect={handleSelectTab}
        />
      ))}
    </TabNav>
  );
}

export default memo(PeopleAccessTabs);
